// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_PreflightLaudosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract de GET /migration/laudos/preflight
 * (controllers/migration/laudos.php::preflight).
 *
 * As fichas de foto DESTA franquia (o item da E6 resolve o pertencimento —
 * a lista global do export ja veio recortada), mais os dois totais laterais
 * que a tela mostra ao lado da tabela.
 */
import type { Migration_PreflightLaudoRow } from './Migration_PreflightLaudoRow'
import type { Migration_VocabularioLaudoRow } from './Migration_VocabularioLaudoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Migration_PreflightLaudosResponseDados {
registros: Migration_PreflightLaudoRow[]
n_movimentacoes: number
n_fotos_sem_item_no_ledger: number
vocabulario: Migration_VocabularioLaudoRow[]
}

export type Migration_PreflightLaudosResponse = ApiResponse<Migration_PreflightLaudosResponseDados>;

registerResponseContract('Migration_PreflightLaudosResponse', {
  registros: {
    type: 'array',
    required: true,
    items: {
      zoho_id:         { type: 'string',  required: false },
      codigo_de_barra: { type: 'string',  required: false },
      n_fotos_antes:   { type: 'number',  required: false },
      n_fotos_depois:  { type: 'number',  required: false },
      tem_video:       { type: 'boolean', required: false },
      alertas:         { type: 'array',   required: false },
      criado_em:       { type: 'string',  required: false },
      ja_migrado:      { type: 'boolean', required: false },
      blockers: {
        type: 'array',
        required: false,
        items: {
          code:     { type: 'string',  required: false },
          message:  { type: 'string',  required: false },
          severity: { type: 'string',  required: false },
          entity:   { type: 'string',  required: false },
          zoho_id:  { type: 'string',  required: false },
          label:    { type: 'string',  required: false },
        },
      },
    },
  },
  n_movimentacoes:            { type: 'number',  required: true },
  n_fotos_sem_item_no_ledger: { type: 'number',  required: true },
  vocabulario: {
    type: 'array',
    required: true,
    items: {
      chave:       { type: 'string',  required: false },
      origem:      { type: 'string',  required: false },
      tipo:        { type: 'string',  required: false },
      report_type: { type: 'string',  required: false },
      destino: {
        type: 'object',
        required: true,
        fields: {
          tabela:       { type: 'string',  required: false },
          chave_origem: { type: 'string',  required: false },
          acao:         { type: 'string',  required: false },
          id:           { type: 'number',  required: false },
          nome:         { type: 'string',  required: false },
          decidido:     { type: 'boolean', required: false },
        },
      },
    },
  },
})
